import { ReactNode, useEffect, useState } from "react"
import { createPortal } from "react-dom"

import { AFTER_FOOTER } from "components/Footer/components/AfterFooter/constants"
import { useIsSSR } from "utils/hooks/useIsSSR"

interface Props {
    children: ReactNode
    afterFooterKey?: string
}

export function AfterFooter({ children, afterFooterKey }: Props) {
    const isSSR = useIsSSR()
    const [afterFooterElement, setAfterFooterElement] = useState<HTMLElement | null>(null)

    useEffect(() => {
        if (!isSSR) setAfterFooterElement(document.getElementById(AFTER_FOOTER))
    }, [afterFooterKey])

    return afterFooterElement ? createPortal(children, afterFooterElement, AFTER_FOOTER) : null
}
